import ZuiContainer from '@zenbusiness/zui/Container';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'AppHeader',
  slot: 'Root',
  tag: ZuiContainer,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    height: theme.spacing(6.5),
    paddingBlock: theme.spacing(1),
    paddingInline: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      height: theme.spacing(8.5),
      paddingBlock: theme.spacing(2),
      paddingInline: theme.spacing(4)
    },

    [theme.breakpoints.up('lg')]: {
      paddingInline: theme.spacing(8)
    }
  })
});

export const Branding = superstyled({
  name: 'AppHeader',
  slot: 'Branding'
});

export const Actions = superstyled({
  name: 'AppHeader',
  slot: 'Actions',
  propsNeeded: ['fullWidth'],
  styles: ({ fullWidth, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: fullWidth ? '100%' : undefined,

    [theme.breakpoints.up('lg')]: {
      width: 'auto'
    }
  })
});
